export enum IconButtonStyle {
  Secondary = 'Secondary',
  // pick other from RoundButtonStyles when needed
}

export type IconButtonSize = 's' | 'm' | 'l';
